import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom'

import { GoogleMapsProvider } from 'modules/core/components/GoogleMaps/GoogleMapsProvider'
import Loading from 'modules/core/components/Loading'

import CreatePerDiemForm from 'modules/expenses/components/expenses/Detail/_newForm/CreatePerDiemForm'
import { PerDiemWizardModal } from 'modules/expenses/components/expenses/New/PerDiemWizard/GermanyModal'
import { fieldEnabled } from 'modules/expenses/hooks/useExpensesCustomization'
import useNewExpensesPage from 'modules/expenses/hooks/useNewExpensesPage'
import type { RouteContextParams } from 'modules/expenses/lib/my_expenses/RouteContextParams'

const NewPerDiemPage = () => {
  const { group } = useOutletContext<RouteContextParams>()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const {
    customizationFields,
    hasProjectsFeature,
    hasReportOnBehalfFeature,
    loading,
    canCreateExpensesForOthers,
    canCustomizeSettings,
    canSeeEmployeeLegalEntity,
    isNewPerDiemWizardEnabled,
    navigation,
  } = useNewExpensesPage()

  const handleClose = () =>
    navigate({
      pathname: navigation.helpers.getExpensesFormBackPath(),
      search: searchParams.toString(),
    })

  if (loading) return <Loading inline />

  if (isNewPerDiemWizardEnabled) {
    return (
      <GoogleMapsProvider mapsEnabled>
        <PerDiemWizardModal onClose={handleClose} />
      </GoogleMapsProvider>
    )
  }

  return (
    <GoogleMapsProvider
      mapsEnabled={
        fieldEnabled(customizationFields, 'perdiem', 'from') ||
        fieldEnabled(customizationFields, 'perdiem', 'to')
      }
    >
      <CreatePerDiemForm
        canCustomizeSettings={canCustomizeSettings}
        customizationFields={customizationFields}
        hasProjectsFeature={hasProjectsFeature}
        canSeeEmployeeLegalEntity={canSeeEmployeeLegalEntity}
        hasReportOnBehalfFeature={hasReportOnBehalfFeature}
        canCreateExpensesForOthers={canCreateExpensesForOthers}
        groupCurrency={group?.currency}
        onClose={handleClose}
      />
    </GoogleMapsProvider>
  )
}

export default NewPerDiemPage
